import { createApi } from '@reduxjs/toolkit/query/react';

import { CategoryWiseProductsResponse } from '@/types/Category';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const ezshipManagerStrapiApi = createApi({
  reducerPath: 'ezshipManagerStrapiApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({
    basePath: '',
    useStrapiServer: true,
    cache: 'no-store',
  }),
  tagTypes: ['AllCategories', 'CategoryDetails'],
  endpoints: builder => ({
    getAllCategoryProducts: builder.query<{ data: CategoryWiseProductsResponse }, void>({
      query: () => ({
        // url: `/api/categories/2183?${getCategoryDetailQueryWithFilters()}`,
        url: '/api/categories/ezship/quickview',
        next: { tags: ['CategoryDetails'] },
      }),

      transformResponse: (response: { data: CategoryWiseProductsResponse }, meta, arg) => {
        return response;
      },
      providesTags: ['CategoryDetails'],
    }),
  }),
});

export const { useGetAllCategoryProductsQuery } = ezshipManagerStrapiApi;
